import type { ThemeWithoutTokens } from '../theme.types';

export const stepperTokens = (theme: ThemeWithoutTokens) =>
  ({
    stepperBackgroundColorCurrent: theme.colors.primary.normal,
    stepperBackgroundColorCompleted: theme.colors.body.background,
    stepperBackgroundColorNotCompleted: theme.colors.disabled.text,
    stepperFontFamily: theme.typography.fontFamily.regular,
    stepperFontSize: theme.typography.fontSize.s,
    stepperFontWeight: theme.typography.fontWeight.bold,
    stepperFontColor: theme.colors.body.textLight,
    stepperBadgeRadius: theme.radiuses.xxl,
    stepperBadgeWidth: theme.space.component.x.xl,
    stepperBadgeHeight: theme.space.component.y.xl,
    stepperLinkLetterSpacing: theme.typography.letterSpacing.m,
    stepperLinkLineHeight: theme.typography.lineHeight.s,
    stepperLinkColorCurrent: theme.colors.primary.normal,
    stepperLinkColorNotCurrent: theme.colors.body.text,
    stepperLinkColorTextDecoration: 'underline',
  }) as const;
